import React, { useEffect, useState } from "react";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import "./PaymentSuccess.css";
import { FaCheckCircle, FaReceipt, FaTachometerAlt, FaClock, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {fetchTransactionDetailsAPI} from "../../actioncreators/actioncreators";
const PaymentSuccess = () => {
  // This would typically come from an API call or URL params
  // For now using static data from the provided JSON
  const [paymentData, setPaymentData] = useState({ });
  
  const navigate = useNavigate();
 

  useEffect(() => {
      fetchTransactionDetail();
    }, []);
  
  const fetchTransactionDetail = async () => {
      try {
        const subscriptionId = localStorage.getItem('subscriptionId');
        
        const payload = {
          id: subscriptionId,
        };
        const response = await fetchTransactionDetailsAPI(payload); 
       
          setPaymentData(response.paymentDetails || {});
      } catch (err) {
        console.error("Error fetching transaction details:", err.message);
      }
    };

  return (
    <Container fluid className="payment-success-container">
      <Row className="justify-content-center w-100">
        <Col md={11} lg={10} xl={8}>
          <Card className="payment-card border-0">
            <Card.Body className="p-3 p-md-4">
              <div className="text-center mb-4">
                <h2 className="success-header mb-2">
                  <FaCheckCircle className="success-icon me-2" />
                  Payment Successful!
                </h2>                <div className="amount-text mb-2">₹ {paymentData?.Amount ? Number(paymentData.Amount).toFixed(2) : '0.00'}</div>
                <p className="text-muted small mb-0">
                  Transaction ID: <span className="fw-semibold" style={{ backgroundColor: '#f8f9fa', padding: '3px 8px', borderRadius: '4px' }}>{paymentData?.Txnid}</span>
                </p>
              </div>

              <Row className="details-row">
                <Col md={6} className="pe-md-2">
                  <div className="payment-details h-100" style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                    <h5 className="mb-3 d-flex align-items-center">
                      <FaReceipt className="me-2 text-primary" /> Payment Details
                    </h5>
                    <div className="payment-info">
                      <div className="detail-item">
                        <span className="text-muted small">Mode</span>
                        <span className="fw-semibold small">{paymentData?.Mode}</span>
                      </div>
                      {paymentData?.mode === "UPI" && (
                        <div className="detail-item mt-2">
                          <span className="text-muted small">UPI ID</span>
                          <span className="fw-semibold small">{paymentData?.UpiVa}</span>
                        </div>
                      )}
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Date</span>
                        <span className="fw-semibold small">
                          {new Date(paymentData?.Addedon).toLocaleDateString()}
                        </span>
                      </div>
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Status</span>
                        <span className="badge bg-success small">{paymentData?.Status}</span>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="ps-md-2 mt-3 mt-md-0">
                  <div className="customer-details h-100" style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                    <h5 className="mb-3 d-flex align-items-center">
                      <FaUser className="me-2 text-primary" /> Customer Details
                    </h5>
                    <div className="customer-info">
                      <div className="detail-item">
                        <span className="text-muted small">Name</span>
                        <span className="fw-semibold small">{paymentData?.Firstname}</span>
                      </div>
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Email</span>
                        <span className="fw-semibold small">{paymentData?.Email}</span>
                      </div>
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Phone</span>
                        <span className="fw-semibold small">{paymentData?.Phone}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="text-center mt-4">
                {/* <div className="processing-status mb-3">
                  <FaClock className="text-primary me-2" />
                  <span className="text-primary">Payment processed successfully!</span>
                </div> */}
                <div className="d-flex justify-content-center">
                  <Button variant="outline-primary" size="sm" className="px-4"  onClick={() => {
                      // Navigate to dashboard
                      navigate("/home");
                    }}>
                    {/* <FaTachometerAlt className="me-1" /> */}
                  Return to Dashboard
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentSuccess;
